var LGFG = LGFG || {};

$(document).ready(function () {
    // Auto-initialize global stuff on document ready

    // Trigger page reload when using back/forward buttons through states triggered by javascript
    window.onpopstate = function (e) {
        location.reload();

    };

    // Try
    $('[data-role="pv-container"]').each(function (i, e) {
        var $this = $(e);
        var _controller = $this.data('controller');
        var _action = $this.data('action');
        var _id = $this.data('id');
        var _endpoint = `/${_controller}/${_action}/${_id}`;
        $this.load(_endpoint);
    });

});

$.urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null){
       return null;
    }
    else {
       return decodeURI(results[1]) || 0;
    }
}